<template>
    <v-container class="background">
        <v-row justify="center" class="mt-10">
            <v-col xs="12" sm="8" md="6">
                <v-card
                    class="blur pa-5"
                    color="rgba(255, 255, 255, 0.90)"
                >
                    <v-form
                        ref="form"
                        @submit.prevent="onSubmit"
                    >
                        <v-row>
                            <v-col cols="12">
                                <h2 class="display-1 mb-2">
                                    Login
                                </h2>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field
                                    label="Email Address"
                                    v-model="email"
                                    validate-on-blur
                                    :rules="[
                                        rules.required,
                                        rules.email
                                    ]"
                                    color="secondary"
                                />
                            </v-col>

                            <v-col cols="12">
                                <v-text-field
                                    label="Password"
                                    v-model="password"
                                    :type="showPassword ? 'text' : 'password'"
                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                    @click:append="showPassword = !showPassword"
                                    validate-on-blur
                                    :rules="[
                                        rules.required
                                    ]"
                                    color="secondary"
                                />
                            </v-col>

                            <v-col cols="12">
                                <div class="d-flex">
                                    <v-spacer />
                                    <v-btn
                                        large
                                        color="primary"
                                        type="submit"
                                        :loading="isSubmitting"
                                        :disabled="isSubmitting"
                                    >
                                        Login
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <div>
                                Don't have an account? <router-link :to="{name: 'signUp'}">Sign Up</router-link>
                            </div>
                            <v-spacer />
                            <div class="text-right">
                                <router-link :to="{name: 'forgotPassword'}">
                                    Forgot Password?
                                </router-link>
                            </div>
                        </div>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserBus from '../utils/buses/UserBus'
import MessageBus from '../utils/buses/MessageBus'
import { defaultError, default422Error } from '../utils/constants/errors'
import { requiredValidation, emailValidation } from '../utils/validations'

export default {
    data () {
        return {
            email: '',
            password: '',
            showPassword: false,
            isSubmitting: false,
            rules: {
                required: requiredValidation,
                email: emailValidation
            }
        }
    },
    methods: {
        onSubmit () {
            if (!this.$refs.form.validate()) {
                MessageBus.sendMessage(default422Error, 'error')
                return
            }

            this.isSubmitting = true

            UserBus.login(this.email, this.password)
                .then(res => {
                    const {
                        handle,
                        handleKey,
                        verified
                    } = UserBus.user

                    if (verified === false) {
                        this.$router.push({
                            name: 'verifyEmail'
                        })
                    } else if (
                        verified === true
                        && !handle
                    ) {
                        this.$router.push({
                            name: 'chooseHandle'
                        })
                    } else {
                        this.$router.push({
                            name: 'profile',
                            params: {
                                handle: handleKey
                            }
                        })
                    }
                })
                .catch(err => {
                    switch (err.status) {
                    case 401:
                        MessageBus.sendMessage('The provided credentials are invalid', 'error')
                        break
                    default:
                        MessageBus.sendMessage(defaultError, 'error')
                        break
                    }
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        }
    }
}
</script>

<style scoped>
.background {
  background-image: url("../assets/friends_online.svg");
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
}
.blur {
  backdrop-filter: blur(8px);
}
</style>
